import { ExperimentType } from 'ha/modules/Experiments';

const Experiments: { [name: string]: ExperimentType } = {
  HA5972: {
    name: '[HA-5972] Cancellation Policies',
    variants: ['A', 'B', 'C'],
    weights: [33.34, 33.33, 33.33],
  },
  HA7595: {
    name: '[HA-7595] Commute time in focused countries',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  HA8438: {
    name: '[HA-8438] Update search date logic',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  HA8501: {
    name: '[HA-8501] Update subscriptions paywall design',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  HA8434: {
    name: '[HA-8434] A/B Test: Shift booking FAQ content from talk page to contact page',
    variants: ['A', 'B'],
    weights: [50, 50],
  },

  /* TNT */
  TNT388: {
    name: '[TNT-388] A/B Test: Account registration in the subscriptions payment flow',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  TNT228: {
    name: '[TNT-228] A/B Test: Registration [LDP]',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  TNT291: {
    name: '[TNT-291] A/B Test: MV test to move rental conditions to booking flow',
    variants: ['A', 'B', 'C', 'D'],
    weights: [25, 25, 25, 25],
  },

  /* Growth */
  GROWTH191: {
    name: '[GROWTH-191] Rent Radar Banner on LDP',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  GROWTH276: {
    name: '[GROWTH-276] Tenant deposit insurance',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  GROWTH486: {
    name: '[GROWTH-486] Content Card on search',
    variants: ['A', 'B'],
    weights: [50, 50],
  },

  /* Payments */
  MON2312: {
    name: '[MON-2312] PayInForm sticky footer',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  MON2260: {
    name: '[MON-2260] Book-request with mandates',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
};

export default Experiments;
